/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_OpenedInputs */

const en_cases_col_opened = /** @type {(inputs: Cases_Col_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opened`)
};

const pt_br2_cases_col_opened = /** @type {(inputs: Cases_Col_OpenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aberto em`)
};

/**
* | output |
* | --- |
* | "Opened" |
*
* @param {Cases_Col_OpenedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_opened = /** @type {((inputs?: Cases_Col_OpenedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_OpenedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_opened(inputs)
	return pt_br2_cases_col_opened(inputs)
});